<template>
    <p>This page doesn't exist.</p>
</template>


<script>
export default {
    name: 'NotFound'
}
</script>
